import { Link } from "react-router-dom";
import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";

const pricingTable = [
  { duration: "3〜8分", price: "0円（無料サンプル）", label: "無料サンプル" },
  { duration: "10〜20分", price: "1,480円", label: "お試し講座" },
  { duration: "21〜35分", price: "2,980円", label: "入門講座" },
  { duration: "36〜50分", price: "4,980円", label: "基礎講座" },
  { duration: "51〜70分", price: "6,980円", label: "実践講座" },
  { duration: "71〜90分", price: "8,980円", label: "中上級講座" },
  { duration: "91〜120分", price: "11,800円", label: "本格講座" },
  { duration: "121〜180分", price: "16,800円", label: "専門講座・まとめ講座" },
];

export default function SellPage() {
  return (
    <div className="min-h-screen bg-ivory">
      <Navbar />
      <main className="pt-20">
        <section className="bg-deep-green py-14 px-4">
          <div className="max-w-screen-xl mx-auto">
            <p className="font-display italic text-gold text-sm tracking-widest mb-3">Sell on TSUGITE</p>
            <h1 className="font-serif text-white text-4xl md:text-5xl font-light mb-3">出品する</h1>
            <p className="text-white/60 text-sm font-sans">あなたの技術を動画講座・教材キットとして出品しましょう。</p>
          </div>
        </section>

        <section className="px-4 py-12">
          <div className="max-w-3xl mx-auto">
            <p className="text-center font-serif text-deep-green text-xl mb-8">出品するカテゴリを選んでください</p>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12">
              <Link to="/sell/video" className="group bg-white rounded-3xl p-8 border-2 border-stone-100 hover:border-teal cursor-pointer transition-all duration-300 hover:-translate-y-1 block">
                <div className="w-16 h-16 flex items-center justify-center bg-teal/10 rounded-2xl mb-5 group-hover:bg-teal/20 transition-colors">
                  <i className="ri-video-line text-teal text-3xl" />
                </div>
                <h2 className="font-serif text-deep-green text-xl mb-2">動画講座を出品</h2>
                <p className="text-charcoal/60 text-sm font-sans leading-relaxed mb-4">
                  録画した技術動画を講座として出品。価格は動画の長さに応じた推奨価格が自動で表示されます。
                </p>
                <div className="flex flex-wrap gap-2">
                  {["ステップ式入力", "推奨価格自動表示", "無料サンプル設定可"].map((f) => (
                    <span key={f} className="text-xs bg-teal/10 text-teal px-2 py-0.5 rounded-full font-sans">{f}</span>
                  ))}
                </div>
                <p className="mt-5 text-teal text-sm font-sans group-hover:font-medium transition-all">動画講座を出品する →</p>
              </Link>

              <Link to="/sell/kit" className="group bg-white rounded-3xl p-8 border-2 border-stone-100 hover:border-gold cursor-pointer transition-all duration-300 hover:-translate-y-1 block">
                <div className="w-16 h-16 flex items-center justify-center bg-gold/10 rounded-2xl mb-5 group-hover:bg-gold/20 transition-colors">
                  <i className="ri-box-3-line text-gold text-3xl" />
                </div>
                <h2 className="font-serif text-deep-green text-xl mb-2">教材キットを出品</h2>
                <p className="text-charcoal/60 text-sm font-sans leading-relaxed mb-4">
                  道具・材料のセットを教材キットとして出品。仕入れ価格を入力すると推奨販売価格を自動計算します。
                </p>
                <div className="flex flex-wrap gap-2">
                  {["推奨価格自動計算", "在庫管理あり", "対応講座紐付け可"].map((f) => (
                    <span key={f} className="text-xs bg-gold/10 text-gold px-2 py-0.5 rounded-full font-sans">{f}</span>
                  ))}
                </div>
                <p className="mt-5 text-gold text-sm font-sans group-hover:font-medium transition-all">教材キットを出品する →</p>
              </Link>
            </div>

            {/* Video Pricing Guide */}
            <div className="bg-white rounded-2xl border border-stone-100 overflow-hidden mb-6">
              <div className="p-6 border-b border-stone-100 flex items-center gap-3">
                <div className="w-8 h-8 flex items-center justify-center">
                  <i className="ri-price-tag-3-line text-teal text-xl" />
                </div>
                <div>
                  <h3 className="font-serif text-deep-green">動画講座の推奨価格表</h3>
                  <p className="text-xs text-charcoal/50 font-sans mt-0.5">動画時間に応じた目安価格。出品時に自動表示されます。</p>
                </div>
              </div>
              <div className="overflow-x-auto">
                <table className="w-full">
                  <thead className="bg-stone-50">
                    <tr>
                      <th className="text-left text-xs text-charcoal/50 font-sans font-medium px-5 py-3">動画の長さ</th>
                      <th className="text-left text-xs text-charcoal/50 font-sans font-medium px-5 py-3">種別</th>
                      <th className="text-right text-xs text-charcoal/50 font-sans font-medium px-5 py-3">推奨価格</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-stone-100">
                    {pricingTable.map((row, i) => (
                      <tr key={i} className="hover:bg-stone-50/50 transition-colors">
                        <td className="px-5 py-3 text-sm font-sans text-charcoal">{row.duration}</td>
                        <td className="px-5 py-3">
                          <span className={`text-xs px-2 py-0.5 rounded-full font-sans ${i === 0 ? "bg-stone-100 text-charcoal/50" : "bg-teal/10 text-teal"}`}>{row.label}</span>
                        </td>
                        <td className="px-5 py-3 text-right font-serif text-charcoal">{row.price}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>

            {/* Kit Pricing Guide */}
            <div className="bg-white rounded-2xl border border-stone-100 overflow-hidden">
              <div className="p-6 border-b border-stone-100 flex items-center gap-3">
                <div className="w-8 h-8 flex items-center justify-center">
                  <i className="ri-calculator-line text-gold text-xl" />
                </div>
                <div>
                  <h3 className="font-serif text-deep-green">教材キットの推奨価格倍率</h3>
                  <p className="text-xs text-charcoal/50 font-sans mt-0.5">仕入れ価格（Amazon等）に対する推奨販売価格の目安。</p>
                </div>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-0 divide-y md:divide-y-0 md:divide-x divide-stone-100">
                {[
                  { plan: "ライトプラン", color: "text-gold", bg: "bg-gold/5", multipliers: [{ range: "〜3,000円", rate: "×1.50（150%）" }, { range: "3,001〜8,000円", rate: "×1.45（145%）" }, { range: "8,001〜15,000円", rate: "×1.40（140%）" }, { range: "15,001円〜", rate: "×1.35（135%）" }] },
                  { plan: "フリープラン", color: "text-teal", bg: "bg-teal/5", multipliers: [{ range: "〜3,000円", rate: "×1.60（160%）" }, { range: "3,001〜8,000円", rate: "×1.55（155%）" }, { range: "8,001〜15,000円", rate: "×1.50（150%）" }, { range: "15,001円〜", rate: "×1.45（145%）" }] },
                ].map((pl) => (
                  <div key={pl.plan} className={`p-5 ${pl.bg}`}>
                    <p className={`font-sans text-sm font-medium mb-3 ${pl.color}`}>{pl.plan}</p>
                    <div className="space-y-2">
                      {pl.multipliers.map((m) => (
                        <div key={m.range} className="flex items-center justify-between">
                          <span className="text-xs text-charcoal/60 font-sans">仕入れ価格 {m.range}</span>
                          <span className="text-xs font-sans font-medium text-charcoal">{m.rate}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
              <div className="p-5 bg-stone-50 border-t border-stone-100">
                <p className="text-xs text-charcoal/50 font-sans">例：仕入れ価格5,000円 → ライトプラン推奨¥7,250 / フリープラン推奨¥7,750</p>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
